import { useEffect } from "react";
const useTabHash = (tabs, onSelect) => {
    useEffect(() => {
        const activateTabFromHash = () => {
            let tabLabel;
            try {
                tabLabel = decodeURIComponent(window.location.hash.slice(1));
            }
            catch {
                return;
            }
            if (!tabLabel) {
                return;
            }
            const index = tabs.findIndex((tab) => tab.title === tabLabel);
            if (index !== -1) {
                onSelect(index);
            }
        };
        activateTabFromHash();
        window.addEventListener("hashchange", activateTabFromHash);
        window.addEventListener("popstate", activateTabFromHash);
        return () => {
            window.removeEventListener("hashchange", activateTabFromHash);
            window.removeEventListener("popstate", activateTabFromHash);
        };
    }, [tabs, onSelect]);
};
export default useTabHash;
